export default "__VITE_ASSET__98cf1213__"